import PropTypes from "prop-types"
import "./style.scss"

export default function ForecastInformation({ selectedForecast, isOpPro }) {
  let label, name
  // When a custom forecast is selected, we display its name in the forecast selector
  if (selectedForecast) {
    label = "Current Forecast"
    name = selectedForecast.name
  // When OPPro and no selected forecast, we display a `null` state for the forecast selector
  } else if (isOpPro) {
    label = "Forecast Selector"
    name = "No selected forecast"
    // When enterprise and no selected forecast, we display Implied Returns as a default forecast
  } else {
    label = "Default Forecast"
    name = "Implied Returns"
  }
  return <div className="forecast-label-wrapper">
    <div className="forecast-label">{label}</div>
    <div className="forecast-selected-name">{name}</div>
  </div>
}

ForecastInformation.propTypes = {
  selectedForecast: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  isOpPro: PropTypes.bool.isRequired,
}
